import request from '@/utils/request'

export function vehicleMap(query) {
  return request({
    url: '/ntocc-tps-api/vehicleMap/location',
    method: 'get',
    params: {
      vehicleCodes: query
    }
  })
}

export function vHisTrack(query) {
  return request({
    url: '/ntocc-tps-api/vehicleMap/vHisTrack24',
    method: 'get',
    params: query
  })
}
export function vHisTrack4Order(query) {
  return request({
    url: '/ntocc-tps-api/vehicleMap/vHisTrack4Order',
    method: 'get',
    params: query
  })
}
export function vAllHisTrack4Order(query) {
  return request({
    url: '/ntocc-tps-api/vehicleMap/vAllHisTrack4Order',
    method: 'get',
    params: query
  })
}
export function vehicleTree(query) {
  return request({
    url: '/ntocc-tps-api/vehicleMap/vehicleTree',
    method: 'get',
    params: query
  })
}

export function orderOcr(data) {
  return request({
    url: '/ntocc-tps-api/ocr',
    method: 'put',
    params: {
      imageUrl: data
    }
  })
}

